export enum PlayerRankingType {
	Score,
	Team
}
